import { useMemo } from 'react';

import { UseGridScrollbarsProps } from './types';

export const useGridScrollbars = ({
  columns_width,
  grid_width,
}: UseGridScrollbarsProps): number => {
  const scrollbar_height = useMemo(() => {
    if (typeof document === 'undefined') return 0;

    const div = document.createElement('div');
    div.style.cssText = `
      position: absolute;
      top: -9999px;
      width: 100px;
      height: 100px;
      overflow: scroll;
      visibility: hidden;
    `;

    document.body.appendChild(div);
    const size = div.offsetHeight - div.clientHeight;
    document.body.removeChild(div);

    return size;
  }, []);

  return useMemo(() => {
    const horizontal_scrollbar = columns_width > grid_width;
    return horizontal_scrollbar ? scrollbar_height : 0;
  }, [columns_width, grid_width, scrollbar_height]);
};
